import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import ProtectedRoute from '../components/ProtectedRoute';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translations';
import { track } from '../utils/analytics';
import '../App.css';
import styles from './LessonGeneratorSelection.module.css';

function LessonGeneratorSelectionContent() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleCreateLessonPlan = () => {
    track('Clicked Create Lesson Plan', { screen_name: 'Lesson Generator Selection' });
    navigate('/create-lesson-plan/form');
  };

  const handleAugmentLessonPlan = () => {
    // TODO: Navigate to augment lesson plan page when implemented
    alert('Augment Lesson Plan feature coming soon!');
  };

  return (
    <div className="app-container">
      <NavBar />
      <div className={styles.container}>
        <div className={styles.headerSection}>
          <h1 className={styles.title}>Tools</h1>
          <p className={styles.subtitle}>
            Create a brand new lesson or start with a lesson that you already have!
          </p>
        </div>

        <div className={styles.optionsContainer}>
          <div className={styles.optionCard} onClick={handleCreateLessonPlan}>
            <div className={styles.cardContent}>
              <h2 className={styles.cardTitle}>Create Lesson Plan</h2>
              <p className={styles.cardDescription}>
                Create a lesson plan, with scripts, worksheets, activities, and more using AI.
              </p>
            </div>
            <div className={styles.cardBadges}>
              <div data-property-1="AI" className={styles.aiBadge}>
                <img
                  src="/assets/Solid/Interface/AI.svg"
                  alt="AI Assisted"
                  className={styles.aiIcon}
                />
                <span className={styles.aiText}>{t('ai_assisted', language)}</span>
              </div>
              <img
                src="/assets/info_icon.svg"
                alt="Info"
                className={styles.infoIcon}
              />
            </div>
          </div>

          {/* HIDDEN: Augment Lesson Plan feature temporarily disabled */}
          {/* <div className={styles.optionCard} onClick={handleAugmentLessonPlan}>
            <div className={styles.cardContent}>
              <h2 className={styles.cardTitle}>Augment Lesson Plan</h2>
              <p className={styles.cardDescription}>
                Upload an existing lesson plan, and adjust, translate, level and more using AI.
              </p>
            </div>
            <div className={styles.cardBadges}>
              <div data-property-1="AI" className={styles.aiBadge}>
                <img
                  src="/assets/Solid/Interface/AI.svg"
                  alt="AI Assisted"
                  className={styles.aiIcon}
                />
                <span className={styles.aiText}>{t('ai_assisted', language)}</span>
              </div>
              <img
                src="/assets/info_icon.svg"
                alt="Info"
                className={styles.infoIcon}
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

function LessonGeneratorSelection() {
  return (
    <ProtectedRoute>
      <LessonGeneratorSelectionContent />
    </ProtectedRoute>
  );
}

export default LessonGeneratorSelection;

